import React from 'react';
import moment from 'moment'
import * as RT from '../../../constants/Routing';
import { Redirect } from 'react-router-dom';
import defaultPhoto from '../../../lib/images/user-thumb-default.png';
import Modal from '../../App/Modal'
import ReactDOM from 'react-dom';
import TermBody from '../../StaticPages/Terms/TermsBody'
import { Helmet } from 'react-helmet'
import * as SG from '../../../constants/AppSettings'

export default class Component extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      'user[name]': props.App.currentUser.name || '',
      'user[email]': props.App.currentUser.email || '',
      'user[birthday]': props.App.currentUser.birthday || '',
      'user[photo]': props.App.currentUser.photo || '',
      'user[gender]': props.App.currentUser.gender || '',
      'user[phone_number]': props.App.currentUser.phone_number || '',
      openModal: false
    };
  };

  validateFileExtensions = (file) => {
    var validFileExtensions = ["jpg", "jpeg", "gif", "png"];
    var fileErrors = new Array();

    var ext = file.name.split('.').pop();

    if (validFileExtensions.indexOf(ext) === -1 ) {
      fileErrors.push('画像は jpg, jpeg, gif, png のいずれかのフォーマットのものを選択する必要があります。')
    }

    if (file.size >= SG.FILE_SIZE_LIMIT) {
      const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
      let ext = sizes[0];
      let size = SG.FILE_SIZE_LIMIT

      if (typeof size === 'number') {
        for (var i = 1; i < sizes.length; i += 1) {
          if (size >= 1024) {
            size = size / 1024;
            ext = sizes[i];
          }
        }
      }

      const limit = this.round(size, 2) + ext;

      fileErrors.push(`ファイルの容量が大きすぎます。 ${limit} 以下のサイズのファイルを選択して下さい。`)
    }

    if (fileErrors.length > 0) {
      this.props.noticeInFirstProfRegist(fileErrors, 'error')
      return false;
    }
    return true;
  }

  round = (value, precision, mode) => {

      var m, f, isHalf, sgn; // helper variables
      precision |= 0; // making sure precision is integer
      m = Math.pow(10, precision);
      value *= m;
      sgn = (value > 0) | -(value < 0); // sign of the number
      isHalf = value % 1 === 0.5 * sgn;
      f = Math.floor(value);

      if (isHalf) {
        switch (mode) {
          case 'PHP_ROUND_HALF_DOWN':
            value = f + (sgn < 0); // rounds .5 toward zero
            break;
          case 'PHP_ROUND_HALF_EVEN':
            value = f + (f % 2 * sgn); // rouds .5 towards the next even integer
            break;
          case 'PHP_ROUND_HALF_ODD':
            value = f + !(f % 2); // rounds .5 towards the next odd integer
            break;
          default:
            value = f + (sgn > 0); // rounds .5 away from zero
        }
      }

      return (isHalf ? value : Math.round(value)) / m;
    
  }

  valueChange = (e) => {
    if (e.target.name === 'user[photo]') {
      var fileSelectDom = e.target;
      var filePreviewBox = document.querySelector('.user-thumb-form')
      var photo = this.state.photo ? this.state.photo : defaultPhoto


      const isValidFile = this.validateFileExtensions(e.target.files[0])

      if (isValidFile) {
        let fileReader = new FileReader();
        fileReader.onload = () => {
          filePreviewBox.style.backgroundImage = `url(${fileReader.result})`
        }
        fileReader.readAsDataURL(fileSelectDom.files[0])
        fileReader.onload()
      } else {
        if (!fileSelectDom.files.length) {
          filePreviewBox.style.backgroundImage = `url(${photo})`
        }
        e.target.value = ''
      }
    }

    this.setState({ [e.target.name]: e.target.value })
    
  }

  checkAllEnter = () => {
    // 全入力チェック
    if (!!this.state['user[name]'] && !!this.state['user[email]'] && !!this.state['user[birthday]'] && !!this.state['user[gender]']) {
      return true
    } else {
      return false
    }
  }

  openModal = () => {
    this.setState({openModal: true})
  }

  closeModal = () => {
    this.setState({openModal: false})
  }

  onSubmit = (e) => {
    e.preventDefault();
    this.openModal()
  }

  submitProfile = () => {
    const form = document.getElementById('user-first-form')
    const fileInput = document.querySelector('.thumb-field')
    if (!fileInput.files.length) fileInput.setAttribute('disabled', '')
    const formData = new FormData(form)
    fileInput.removeAttribute('disabled')
    this.props.firstProfRegist(formData)
  }

  componentDidMount = () => {
    const userThumbBox = document.querySelector('.user-thumb-form')
    function clickFileInput() {
      const fileInput = document.querySelector('.thumb-field')
      fileInput.click()
    }
    userThumbBox.addEventListener('click', clickFileInput)
  }

  componentDidUpdate = () => {
    if (this.props.FirstProfRegist.Result === 'error' && !this.props.FirstProfRegist.Loading && this.state.openModal) {
      this.props.resetState()
      this.setState({ openModal: false })
    }
  }

  render = () => {

    const currentUser = this.props.App.currentUser
    const currentPath = this.props.location.pathname

    const photo = this.state['user[photo]'] ? this.state['user[photo]'] : defaultPhoto

    const thumbStyle = {
      backgroundImage: `url(${photo})`,
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      width: '150px',
      height: '150px',
      margin: '0 auto 15px',
      borderRadius: '50%'
    }

    const metaInfo = (
      <Helmet>
        <title>プロフィール登録 | {SG.META_TITLE}</title>
        <meta name='description' content='サークルー(circrew)プロフィール確認ページです。ユーザー登録の際にプロフィールの項目が必要になります。プロフィールではプロフィール写真、名前、生年月日、メードアドレスを取得します。' />
      </Helmet>
    )

    let modal;
    modal = (
      <Modal
        okClickHandler={this.submitProfile}
        headerTitle='利用規約に同意して登録'
        okText='同意する'
        isOpen={this.state.openModal}
        closeModal={this.closeModal}
      >
        <TermBody />
      </Modal>
    )


    return (
      <form id='user-first-form' className='' onSubmit={this.onSubmit}>
        {ReactDOM.createPortal(modal, document.getElementById('dialogSpace'))}
        {metaInfo}
        <div className='container'>
          {(() => {
            // ユーザー情報を入力済みのときのリダイレクト処理
            if (!!localStorage.getItem('token') && !!currentUser) {
              if ((!!currentUser.registered_at && currentPath === RT.USER_FIRST_PROF_PATH) || (!!currentUser.registered_at && this.props.FirstProfRegist.Loaded)) {
                return (
                  <Redirect to={RT.USER_MYPAGE_PATH} />
                )
              }
            }
          })()}
          
          <h2 className='headline'>登録完了まであと少しです！</h2>
          <div className='user-thumb-form shadow-sm' style={thumbStyle}>
            <input type='file' name='user[photo]' className='d-none thumb-field ' onChange={this.valueChange} accept=".jpg,.gif,.png,image/gif,image/jpeg,image/png" />
            <i className="material-icons">add</i>
          </div>
          <table className='table table-borderless'>
            <tbody>
              <tr>
                <th><label htmlFor='user[name]'>名前</label></th>
                <td><input type='text' name='user[name]' value={this.state['user[name]']} onChange={this.valueChange} required /></td>
              </tr>
              <tr>
                <th><label htmlFor='user[phone_number]'>電話番号<br />(ハイフンあり)</label></th>
                <td><input type='text' name='user[phone_number]' value={this.state['user[phone_number]']} onChange={this.valueChange} required /></td>
              </tr>
              <tr>
                <th><label htmlFor='user[email]'>メール</label></th>
                <td><input type='email' name='user[email]' value={this.state['user[email]']} onChange={this.valueChange} required /></td>
              </tr>
              <tr>
                <th><label htmlFor='user[birthday]'>生年月日</label></th>
                <td><input type='date' name='user[birthday]' max={moment().format("YYYY-MM-DD")} value={this.state['user[birthday]']} onChange={this.valueChange} required />
                <p className='notice-text'>あとで変更できません。</p></td>
              </tr>
              <tr>
                <th><label htmlFor='user[gender]'>性別</label></th>
                <td>
                  <div className='radio-wrap'>
                    <input type="radio" name="user[gender]" value="male" id="male" checked={this.state["user[gender]"] === "male"} onChange={this.valueChange} />
                    <label htmlFor="male">男性</label>
                  </div>
                  <div className='radio-wrap'>
                    <input type="radio" name="user[gender]" value="female" id="female" checked={this.state["user[gender]"] === "female"} onChange={this.valueChange} />
                    <label htmlFor="female">女性</label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          {(() => {
            if (this.checkAllEnter()) {
              return (
                <input type='submit' className='btn btn-submit d-block btn-block' value='登録する' />
              )
            } else {
              return(
                <input type="submit" className='btn btn-submit disabled d-block btn-block' disabled value='登録する' />
              )
            }
          })()}
        </div>
      </form>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/User/FirstProfRegist/FirstProfRegist.jsx